module.exports = __webpack_public_path__ + "img/Group11.5b366572.png";